// import React, { useEffect, useState } from "react";
// import Layout from "../components/Layout";
// import Drawer from "../components/Drawer";
// import Loader from "../components/Loader";
// import axios from "axios";
// import { baseUrl, liveMatchesApi, recentMatchesApi } from "../api/api";
// import { toast } from "react-toastify";
// import moment from "moment-timezone";
// import classes from "../css/HomePage.module.css";
// import MatchLayout from "../components/MatchLayout";
// import { useSelector } from "react-redux";

// const RecentPage = () => {
//   const [loading, setLoading] = useState(true);
//   const [recentMatches, setRecentMatches] = useState([]);
//   const [todayMatches, setTodayMatches] = useState([]);
//   const [todayMatchesResults, setTodayMatchesResults] = useState([]);

//   const { lang } = useSelector((state) => state.langSlice);

//   const fetchDataFromBackend = async (loader) => {
//     try {
//       if (loader?.loading) {
//         setLoading(true);
//       }

//       const timezone = moment.tz.guess();

//       const res = await axios.get(`${baseUrl}${liveMatchesApi}`, {
//         params: {
//           timezone,
//           date: moment().tz(timezone).format("YYYY-MM-DD"),
//           league_id: 39,
//         },
//       });

//       setTodayMatches(
//         res?.data?.response?.data?.filter(
//           (data) =>
//             data.matchStatus !== "Match Finished" && data.matchTime == null,
//         ) || [],
//       );

//       // LIVE MATCHES PREMIERE LEAGUE

//       setTodayMatchesResults(
//         res?.data?.response?.data?.filter(
//           (data) => data.matchStatus === "Match Finished",
//         ) || [],
//       );

//       console.log(res, "response....");
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       toast.error(
//         error?.response?.data?.message ||
//           error?.data?.message ||
//           error?.message ||
//           error,
//       );
//     }
//   };

//   const fetchRecentMatchesFromBackend = async () => {
//     try {
//       setLoading(true);

//       const res = await axios.get(`${baseUrl}${recentMatchesApi}`, {
//         params: {
//           league_id: 39,
//         },
//       });

//       console.log(res.data, "recent matches response");

//       // setRecentMatches(
//       //   res?.data?.response?.filter(
//       //     (data) => data.matchStatus === "Match Finished"
//       //   )
//       // );
//       setRecentMatches(
//         res?.data?.response?.filter(
//           (data) => data.matchStatus === "Match Finished",
//         ) || [],
//       );

//       setLoading(false);
//     } catch (error) {
//       setLoading(false);

//       toast.error(
//         error?.response?.data?.message ||
//           error?.message ||
//           "Something Went Wrong!",
//       );

//       console.log(error, "recent matches error");
//     }
//   };

//   useEffect(() => {
//     fetchDataFromBackend({ loading: true });
//     fetchRecentMatchesFromBackend();
//     const intervalId = setInterval(() => {
//       if (!document.hidden) {
//         fetchDataFromBackend({ loading: false });
//       }
//     }, 30000);
//     return () => clearInterval(intervalId);
//   }, []);

//   return (
//     <Layout active={2}>
//       <Drawer active={2} />
//       {loading ? (
//         <Loader />
//       ) : (
//         <>
//           <div className={classes.matches_container}>
//             {todayMatchesResults.length > 0 && (
//               <>
//                 <div className={classes.heading_container}>
//                   <h1 className={classes.heading}>
//                     {lang == "english"
//                       ? "Today Recent Matches"
//                       : lang == "spanish"
//                         ? "Hoy Partidos recientes"
//                         : lang == "french"
//                           ? "Matchs récents d'aujourd'hui"
//                           : lang == "arabic"
//                             ? "آخر مباريات اليوم"
//                             : "Today Recent Matches"}
//                   </h1>
//                 </div>
//                 {todayMatchesResults?.map((match, index) => {
//                   return <MatchLayout match={match} key={index} />;
//                 })}
//               </>
//             )}
//             {todayMatches.length > 0 && (
//               <>
//                 <div className={classes.heading_container}>
//                   <h1 className={classes.heading}>
//                     {lang == "english"
//                       ? "Upcoming Matches Today"
//                       : lang == "spanish"
//                         ? "Próximos partidos de hoy"
//                         : lang == "french"
//                           ? "Matchs à venir aujourd'hui"
//                           : lang == "arabic"
//                             ? "المباريات القادمة اليوم"
//                             : "Upcoming Matches Today"}
//                   </h1>
//                 </div>

//                 {todayMatches?.map((match, index) => {
//                   return <MatchLayout match={match} key={index} />;
//                 })}
//               </>
//             )}

//             <div className={classes.heading_container}>
//               <h1 className={classes.heading}>
//                 {lang == "english"
//                   ? "Recent Matches"
//                   : lang == "spanish"
//                     ? "Partidos recientes"
//                     : lang == "french"
//                       ? "Matchs récents"
//                       : lang == "arabic"
//                         ? "المباريات الأخيرة"
//                         : "Recent Matches"}
//               </h1>
//             </div>
//             {recentMatches?.length > 0 ? (
//               recentMatches?.map((match, index) => {
//                 return <MatchLayout match={match} key={index} />;
//               })
//             ) : (
//               <div className={classes.message_box}>
//                 <p className={classes.message}>
//                   {lang == "english"
//                     ? "There are no recent matches currently in this week.."
//                     : lang == "spanish"
//                       ? "No hay partidos recientes actualmente en esta semana."
//                       : lang == "french"
//                         ? "Il n’y a pas de matchs récents actuellement cette semaine."
//                         : lang == "arabic"
//                           ? "لا توجد مباريات أخيرة حاليا في هذا الأسبوع."
//                           : "There are no recent matches currently in this week.."}
//                 </p>
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </Layout>
//   );
// };

// export default RecentPage;


import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import Loader from "../components/Loader";
import axios from "axios";
import { baseUrl, recentMatchesApi } from "../api/api";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import classes from "../css/HomePage.module.css";
import MatchLayout from "../components/MatchLayout";
import { useSelector } from "react-redux";
 
const RecentPage = () => {
  const [loading, setLoading] = useState(true);
  const [recentMatches, setRecentMatches] = useState([]);
  const [todayMatchesResults, setTodayMatchesResults] = useState([]);
 
  const { lang } = useSelector((state) => state.langSlice);
 
  const getMatchDateTime = (match) =>
    match?.match_date_time ?? match?.time ?? match?.date;
 
  const isMatchToday = (match, today, timezone) => {
    const matchDateTime = getMatchDateTime(match);
    if (!matchDateTime) {
      return false;
    }
 
    const matchDate = moment.tz(matchDateTime, timezone);
    return matchDate.isValid() && matchDate.isSame(today, "day");
  };
 
  const fetchMatches = async (showLoader) => {
    try {
      if (showLoader) {
        setLoading(true);
      }
      const timezone = moment.tz.guess();
      const recentResponse = await axios.get(`${baseUrl}${recentMatchesApi}`);
      const recentFixtures = recentResponse?.data?.response;
 
      if (!Array.isArray(recentFixtures)) {
        throw new Error("Unexpected matches response from the server.");
      }
 
      const today = moment.tz(timezone);
      const finishedMatches = recentFixtures.filter(
        (match) => match.matchStatus === "Match Finished"
      );
      const finishedToday = finishedMatches.filter((match) =>
        isMatchToday(match, today, timezone)
      );
      const olderFinishedMatches = finishedMatches
        .filter((match) => !isMatchToday(match, today, timezone))
        .sort(
          (a, b) =>
            moment.tz(getMatchDateTime(b), timezone).valueOf() -
            moment.tz(getMatchDateTime(a), timezone).valueOf()
        );
 
      setTodayMatchesResults(finishedToday);
      setRecentMatches(olderFinishedMatches);
    } catch (error) {
      console.error("Error loading recent matches:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to load matches. Please try again.",
        { toastId: "recent-matches-load-error" }
      );
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    fetchMatches(true);
    const intervalId = setInterval(() => {
      if (!document.hidden) {
        fetchMatches(false);
      }
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);
 
  return (
    <Layout active={2}>
      <Drawer active={2} />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={classes.matches_container}>
            {todayMatchesResults.length > 0 && (
              <>
                <div className={classes.heading_container}>
                  <h1 className={classes.heading}>
                    {lang == "english"
                      ? "Today Recent Matches"
                      : lang == "spanish"
                      ? "Hoy Partidos recientes"
                      : lang == "french"
                      ? "Matchs récents d'aujourd'hui"
                      : lang == "arabic"
                      ? "آخر مباريات اليوم"
                      : "Today Recent Matches"}
                  </h1>
                </div>
                {todayMatchesResults?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}
            <div className={classes.heading_container}>
              <h1 className={classes.heading}>
                {lang == "english"
                  ? "Recent Matches"
                  : lang == "spanish"
                  ? "Partidos recientes"
                  : lang == "french"
                  ? "Matchs récents"
                  : lang == "arabic"
                  ? "المباريات الأخيرة"
                  : "Recent Matches"}
              </h1>
            </div>
            {recentMatches?.length > 0 ? (
              recentMatches?.map((match, index) => {
                return <MatchLayout match={match} key={index} />;
              })
            ) : (
              <div className={classes.message_box}>
                <p className={classes.message}>
                  {lang == "english"
                    ? "There are no recent matches currently in this week.."
                    : lang == "spanish"
                    ? "No hay partidos recientes actualmente en esta semana."
                    : lang == "french"
                    ? "Il n’y a pas de matchs récents actuellement cette semaine."
                    : lang == "arabic"
                    ? "لا توجد مباريات أخيرة حاليا في هذا الأسبوع."
                    : "There are no recent matches currently in this week.."}
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </Layout>
  );
};
 
export default RecentPage;